import { render, staticRenderFns } from "./UserSecurityChangePassword.vue?vue&type=template&id=05082083&"
import script from "./UserSecurityChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserSecurityChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports